<template>
  <wow-card :show-title="false" elevation="0">
    <form>
      <v-row>
        <v-col cols="12" md="3" lg="3" xs="12" sm="4">
          <div class="info-row content body-1">
            <b> .csv file must contain<br /></b>
            <ul>
              <li><strong>productid:</strong> Product ID</li>
              <li><strong>quantity:</strong> BOM Quantity</li>
            </ul>
          </div>
        </v-col>
        <v-col cols="12" md="9" lg="9" xs="12" sm="8">
          <div class="d-flex flex-column">
            <wow-card :show-title="false" outlined>
              <div class="d-flex justify-end">
                <a class="button is-link accent white--text"
                  href="https://intellitots.s3.ap-south-1.amazonaws.com/wowKitBOMDummyFile.csv" download>
                  Download dummy file
                </a>
              </div>
              <div class="d-flex flex-row mt-n2" v-if="recordInsertFlag">
                <v-chip class="ma-2 success" text-color="white">
                  <v-avatar left class="green darken-4">
                    {{ recordInsertSuccess }}
                  </v-avatar>
                  Success
                </v-chip>
                <v-chip class="ma-2 error">
                  <v-avatar left class="red darken-4">
                    {{ recordInsertFailed }}
                  </v-avatar>
                  Failure
                </v-chip>
              </div>
              <v-autocomplete v-model="selectedModel" placeholder="--Select Model--" :items="modelArray" key="model"
                item-text="title" item-value="id" style="width:30%;"
                @change="validateConfigurationModel()"></v-autocomplete>
              <div v-if="isValidConfiguration">
                <v-file-input v-model="csvWowKitFiles" placeholder="Upload CSV File" label="Upload CSV File"
                  @change="validateCsvFile" accept=".csv" @click:clear="removeCsvFile" />
                <v-divider class="my-0 py-0"></v-divider>
                <v-card-actions class="justify-end">
                  <v-btn :disabled="!uploadBtnFlag" @click.prevent="UploadCsvFile" color="accent">Upload</v-btn>
                  <v-btn :disabled="!faliedBtnFlag" @click.prevent="exportToCSV" color="error">Failed</v-btn>
                </v-card-actions>
                <v-divider class="my-0 py-0 mb-2"></v-divider>
                <span class="red--text"><b>Note:</b> Please don't refresh the page or navigate elsewhere while upload is
                  in progress. You won't be able to download the failed file once you refresh this page or navigate to
                  another
                  page.</span>
              </div>
            </wow-card>
          </div>
        </v-col>
      </v-row>
      <v-card-actions v-if="csvFileValid" class="justify-end">
        <v-btn color="success" @click.prevent='createBomConfiguration'>Proceed</v-btn>
        <v-btn color="primary" @click="closeCreateNewConfigDialog">Cancel</v-btn>
      </v-card-actions>
    </form>
  </wow-card>
</template>
<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import WowCard from './vCard'
import csvtojsonV2 from 'csvtojson'
import ExportUtility from '@/utils/exportUtility'
export default {
  name: 'newConfigurationDialog',
  components: {
    WowCard
  },
  props: {
    modelArray: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selectedModel: null,
      csvWowKitFiles: null,
      csvFileValid: false,
      uploadBtnFlag: false,
      faliedBtnFlag: false,
      jsonData: [],
      defaultCSVHeader: ['productid', 'quantity'],
      failedCsvDataList: [],
      recordInsertSuccess: 0,
      recordInsertFailed: 0,
      recordInsertFlag: false,
      isValidConfiguration: false
    }
  },
  methods: {
    closeCreateNewConfigDialog: function () {
      this.$emit('close')
    },
    validateConfigurationModel: async function () {
      try {
        this.isValidConfiguration = false
        let res = await http.get(`${constants.API_URL}/api/wow-kit/validate-model-wow-kit?modelID=${this.selectedModel}`)
        if (res.status === 200) {
          if (res.data === true) {
            this.isValidConfiguration = true
          }
        }
      } catch (e) {
        const errMsg = e.response.data.message || e.response.message
        this.errMsg(errMsg)
      }
    },
    validateCsvFile: function () {
      if (this.csvWowKitFiles) {
        this.resetInsertRecord()
        this.csvFileValid = false
        this.faliedBtnFlag = false
        this.uploadBtnFlag = true
        let uploadErrorMsg = 'Please Upload Valid CSV file'
        let file = this.csvWowKitFiles
        this.readerFile(file, async (e) => {
          try {
            this.jsonData = await csvtojsonV2().fromString(e.target.result)
            if (this.jsonData.length > 0) {
              let invalidCsv = false
              let getCsvHeaders = Object.keys(this.jsonData[0])
              getCsvHeaders.forEach(csvKey => {
                if (this.defaultCSVHeader.indexOf(csvKey) === -1) {
                  invalidCsv = true
                }
              })
              if (invalidCsv) {
                this.csvWowKitFiles = null
                this.uploadBtnFlag = false
                this.errMsg(uploadErrorMsg)
                return false
              }
              let checkValidCsvData = false
              this.jsonData.forEach(item => {
                if (
                  (_.isEmpty(item.productid) || parseInt(item.productid) === 0) ||
                  (_.isEmpty(item.quantity) || parseInt(item.quantity) === 0)
                ) {
                  checkValidCsvData = true
                } else {
                  item.productid = parseInt(item.productid)
                  item.quantity = parseInt(item.quantity)
                }
              })
              if (checkValidCsvData) {
                this.csvWowKitFiles = null
                this.uploadBtnFlag = false
                this.errMsg(uploadErrorMsg)
                return false
              }
            } else {
              this.csvWowKitFiles = null
              this.uploadBtnFlag = false
              this.errMsg(uploadErrorMsg)
              return false
            }
          } catch (e) {
            this.csvWowKitFiles = null
            this.uploadBtnFlag = false
            this.errMsg(uploadErrorMsg)
            return false
          }
        })
      }
    },
    UploadCsvFile: async function () {
      try {
        let isDuplicateProduct = false
        let inValidQuantity = false
        let productListArray = []
        // Check for Invalid Product Quantity
        this.jsonData.forEach(obj => {
          if (obj.quantity < 0) {
            if (!inValidQuantity) {
              inValidQuantity = true
            }
            obj.status = 'Provided BOM quantity is incorrect'
          }
          productListArray.push(obj)
        })
        if (inValidQuantity) {
          this.failedCsvDataList = productListArray
          this.faliedBtnFlag = true
          return
        }
        if (productListArray.length > 0) {
          productListArray = []
        }
        let groupByProductID = _.groupBy(this.jsonData, 'productid')
        this.jsonData.forEach(obj => {
          if (groupByProductID[obj.productid].length > 1) {
            if (!isDuplicateProduct) {
              isDuplicateProduct = true
            }
            obj.status = 'Duplicate Entry'
          }
          productListArray.push(obj)
        })
        if (isDuplicateProduct) {
          this.failedCsvDataList = productListArray
          this.faliedBtnFlag = true
          return
        }
        let payload = {}
        payload.model = this.selectedModel
        payload.csvfile = this.jsonData
        let res = await http.post(`${constants.API_URL}/api/wow-kit/validatecsv`, payload)
        if (res.status === 200) {
          if (res.data.status === 99 && !res.data.isValid) {
            this.failedCsvDataList = res.data.data
            this.faliedBtnFlag = true
          } else {
            this.csvFileValid = true
          }
        }
      } catch (e) {
        const errMsg = e.response.data.message || e.response.message
        this.errMsg(errMsg)
      }
    },
    createBomConfiguration: async function () {
      try {
        let payload = {}
        payload.model = this.selectedModel
        payload.csvfile = this.jsonData
        let res = await http.post(`${constants.API_URL}/api/wow-kit/wowkit-bulkcreate`, payload)
        if (res.status === 200) {
          if (res.data.response) {
            this.recordInsertFlag = true
            this.recordInsertFailed = res.data.response.failed
            this.recordInsertSuccess = res.data.response.success
          }
          this.okMsg(res.data.message)
          this.selectedModel = null
          this.removeCsvFile()
          this.$emit('close')
        } else {
          this.errMsg('Failed to create BOM Configuration Data.')
        }
      } catch (e) {
        const errMsg = e.response.data.message || e.response.message
        this.errMsg(errMsg)
      }
    },
    resetInsertRecord: function () {
      this.recordInsertFlag = false
      this.recordInsertFailed = 0
      this.recordInsertSuccess = 0
    },
    readerFile: function (file, onLoadCallback) {
      let reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    removeCsvFile () {
      this.faliedBtnFlag = false
      this.uploadBtnFlag = false
      this.csvFileValid = false
      this.csvWowKitFiles = null
      this.jsonData = []
    },
    exportToCSV () {
      ExportUtility.convertToCsv(this.failedCsvDataList, 'wowKitProduct')
    },
    okMsg: function (msg) {
      return this.$dialog.notify.info(msg, {
        position: 'top-right',
        color: 'success',
        timeout: 4000
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
